import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, TextField, Typography, Container, Paper, Grid, Button } from '@mui/material';
import schema from '../samples/schema.json';
import uischema from '../samples/uischema.json';
import initialData from '../samples/data.json';
import { sendBroadcast } from '../utils/broadcastUtils';

const TestPage: React.FC = () => {
  const [schemaText, setSchemaText] = useState(JSON.stringify(schema, null, 2));
  const [uiSchemaText, setUiSchemaText] = useState(JSON.stringify(uischema, null, 2));
  const [dataText, setDataText] = useState(JSON.stringify(initialData, null, 2));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const payload = {
        schema: JSON.parse(schemaText),
        uischema: JSON.parse(uiSchemaText),
        data: JSON.parse(dataText),
      };
      sendBroadcast('load-content', payload);
    } catch (error) {
      console.error('Invalid JSON format:', error);
      alert('Please ensure all fields contain valid JSON before submitting.');
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <nav style={{ padding: '10px', borderBottom: '1px solid #ccc', marginBottom: '20px' }}>
          <Link to="/" style={{ marginRight: '15px' }}>Form Renderer</Link>
          <Link to="/test">Configuration Test</Link>
        </nav>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Configuration Test Page
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off" sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                label="Schema"
                multiline
                rows={10}
                value={schemaText}
                onChange={(e) => setSchemaText(e.target.value)}
                fullWidth
                variant="outlined"
                InputProps={{ style: { fontFamily: 'monospace', fontSize: '0.8rem' } }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                label="UI Schema"
                multiline
                rows={10}
                value={uiSchemaText}
                onChange={(e) => setUiSchemaText(e.target.value)}
                fullWidth
                variant="outlined"
                InputProps={{ style: { fontFamily: 'monospace', fontSize: '0.8rem' } }}
              />
            </Grid>
          </Grid>
          <TextField
            label="SampleData"
            multiline
            rows={10}
            value={dataText}
            onChange={(e) => setDataText(e.target.value)}
            fullWidth
            variant="outlined"
            InputProps={{ style: { fontFamily: 'monospace', fontSize: '0.8rem' } }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ mt: 2, alignSelf: 'flex-end' }}
          >
            Submit
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default TestPage;